import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import{HttpClient} from '@angular/common/http';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {
  formContacto: FormGroup;
  submitted = false;
  recaptcha: any;
  btnShow:boolean=true;
  key:string= '6LfpjOYUAAAAALHbCquNNFR9eHrVYMsC_ZiLs0sO';
  
  errorMessage:any;

  loading:boolean=false;

  constructor(private http:HttpClient,private formBuilder: FormBuilder) { }
 
    ngOnInit() {
        this.formContacto = this.formBuilder.group({
          comentarioCon:  ['', Validators.required],
          nombreCon: ['', [Validators.required, Validators.pattern('^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF_ ]+$')]],
          correoCon: ['', [Validators.required, Validators.email]],  
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.formContacto.controls; }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.formContacto.invalid) {
            return;
        }
        Swal.fire({
          title: '¡Casi listo!',
          text: 'Por favor, presione OK para envíar el correo.',
          showCancelButton: true,
          confirmButtonColor: '#FF6720',
          cancelButtonColor: '#8a8a8a',
          confirmButtonText: 'Enviar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
             this.loading=true;
           this.http.post<any>(environment.baseURL+'/Contacto?Mensaje='+this.formContacto.value.comentarioCon+'&Correo='+this.formContacto.value.correoCon+'&Nombre='+this.formContacto.value.nombreCon, null).subscribe({
              next: data => {
                this.loading=false;
                  Swal.fire({
                    icon: 'success',
                    title: 'Sus correo ha sido envíado correctamente.',
                    timer: 6000,
                    allowOutsideClick: false
                  }).then((result)=>{
                    if (result.dismiss === Swal.DismissReason.timer) {window.open('contacto', '_self');}
                    if (result.isConfirmed){window.open('contacto', '_self');}
                  });
              }, error: error => {
                this.loading=false;
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: 'Algo salio mal, por favor vuelva a intentarlo'
                })
                  this.errorMessage = error.message;
                  console.error('Hubo un error!', error);
              }
            })
          }else if (result.isDenied) {
            return;
          }
        })
    }
    

    resolved(captchaResponse:any){
      this.recaptcha=captchaResponse;
      this.btnShow=false;
      if(captchaResponse===null){
        this.btnShow=true;
      }
    }


}
